<template>
  <IconSvg class="MenuArrowsDown" :name="'icon-IconDown_Menu'" />
</template>

<script setup>

</script>

<style lang="scss">
.MenuArrowsDown{
  font-size: 8px;
}
</style>

